export default {
    app: {
        main_menu: {
            home: 'Dashboard',
            referrals: 'Referrals',
            referrals_received: 'Received',
            referrals_made: 'Made',
            availability: 'Availability',
            availability_main_location: 'Main location',
            practice: 'Practice',
            practice_members: 'Members',
            practice_profile: 'Profile',
            practice_hours: 'Practice hours',
            my_hours: 'My hours',
            network: 'My Network',
            network_members: 'Member Directory',
            network_favorites: 'Favorites',
            network_browse: 'Browse',
            network_invite_physicians: 'Invite providers',
            network_invite_service_providers: 'Invite service providers',
            network_invitations: 'My Invitations',
            claim_your_profile: 'Claim your profile',
            mma_invites_member: 'MMA invites member',
            plan_billing: 'Plan & billing',
            referrals_pool: 'Referrals pool',
            referrals_pool_received: 'Received',
            referrals_pool_made: 'Made',
        },
        sidenav: {
            current_physician: 'Current active provider',
        },
        topnav: {
            make_referal: 'Make a referral',
            track_referrals: 'Track referrals',
            direct_referral: 'Direct referral',
            direct_referral_description: 'Refer directly to a provider',
            match_referral: 'Match referral',
            match_referral_description: 'Match patient to a provider based on search criteria',
            received_referrals: 'Referrals received',
            made_referrals: 'Referrals made',
            direct_physican: 'Direct to Provider',
            direct_ancillary: 'Direct to Ancillary',
            match_physican: 'Match Provider',
            match_ancillary: 'Match Ancillary',
            eprescribe: 'Digital Referral Script',
            eprescribe_description: 'Send electronic prescriptions to your patient',
        },
        user_menu: {
            activate_physician: 'Activate Provider',
            search_member: 'Search {practice} member',
            location_scope: {
                my: 'My practice location',
                all: 'All practice locations',
            },
            manage_account: 'Manage personal account',
            manage_practice: 'Manage {practice} account',
            logout: 'Log out',
            profile: {
                my_profile: 'My Profile',
                manage_account: 'Manage {physicianFirstName} {physicianLastName} MD account',
            },
        },
    },
}
